import React from 'react'
import type { Notification } from '@ztechapps/common.contract'
import { LocalDateTime } from '@ztechapps/webui.date'
import { HorizontalStack, Icon, Scrollable, ShowIf, TooltipPopOver } from '@ztechapps/webui.util'
import { RichTextDisplay } from '@ztechapps/webui.input'
import { truncate } from '@ztechapps/common.utils'
import { useNotificationListContext } from './Context'
import { BusyButtonLink } from '@ztechapps/webui.button'
import type { EntityWithSelection } from '@ztechapps/common.hook'
import { CheckboxBodyCell } from '../../DataTable/table-body/CheckboxBodyCell'
import { RowNumberBodyCell } from '../../DataTable/table-body/RowNumberBodyCell'
import type { BodyRowConfig } from '../../DataTable/types'

export const ListRow = (props: BodyRowConfig<EntityWithSelection<Notification>>) => {
  const { isRead, createdAt, bodyPlain, bodyHtml, title, _id, _selected } = props
  const { handleUpdate, notificationListWithSelection, loading, notifications } = useNotificationListContext()
  const { toggleSelectBy } = notificationListWithSelection
  return (
    <>
      <RowNumberBodyCell {...props} />
      <CheckboxBodyCell
        checked={_selected}
        onChange={() => {
          toggleSelectBy((item) => item._id === _id)
        }}
      />
      {props._renderDataBodyCell({
        title: (
          <HorizontalStack gap={1}>
            <BusyButtonLink
              icon={isRead ? 'envelope-open' : 'envelope'}
              onClick={() => {
                handleUpdate({ filter: { _id }, input: { isRead: !isRead } })
              }}
              disabled={loading || notifications?.loading}
              isBusy={loading}
              busyText={''}
            />
            <div>{title}</div>{' '}
          </HorizontalStack>
        ),
        createdAt: <LocalDateTime value={createdAt} />,
        bodyPlain: (
          <HorizontalStack gap={1}>
            <TooltipPopOver
              showHeader
              placement={'top'}
              flip
              tooltipBody={
                <Scrollable height="300px">
                  <div style={{ maxWidth: '60vh' }}>
                    {/* trustedSource: notification bodies are system-generated from our own templates, not attacker-reachable */}
                    <RichTextDisplay contentHtml={bodyHtml ?? bodyPlain} className="p-1" trustedSource />
                  </div>
                </Scrollable>
              }
            >
              <div className={'text-primary'}>
                <Icon name="info-circle" />
              </div>
            </TooltipPopOver>
            <div>{truncate(bodyPlain, 100)}</div>
          </HorizontalStack>
        ),
        isRead: (
          <ShowIf condition={isRead}>
            <div className="text-break">
              <Icon className={'text-primary'} name={'check'} />
            </div>
          </ShowIf>
        ),
      })}
    </>
  )
}
